import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/providers/auth.service';
import { PasskeyService } from 'src/app/providers/passkey.service';
import { CommonService } from 'src/app/providers/common.service';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-passkey',
  templateUrl: './passkey.component.html',
  styleUrls: ['./passkey.component.scss'],
  providers: [MessageService]
})
export class PasskeyComponent implements OnInit {
  @Input() logIntoSetUp: boolean = false;
  currentUser: any;
  isMfaEnabled = false;
  mfaData: any = {};
  mfaTitle = "Multi-Factor Authentication (MFA)";
  mfaContent = "To keep your account secure, please verify your identity before registering fingerprint.";
  apiName = apiLinks.mfa.passkeyOTPVerify;
  formData: any = {};
  isLoading = false;
  mfaToken: string = '';
  devices: any[] = [];
  error: string = '';
  isShowDeviceList:boolean = false;
  loader : boolean = true;
  showRegistrationForm: boolean = false;
  isCurrentDeviceRegistered: boolean = false;
  isDeleteDevice: boolean = false;
  hideMessage: boolean = true;
  deletingDeviceId: string | null = null;
  readonly MAX_DEVICES: number = 3;

  constructor(
    private readonly authService: AuthService, 
    private readonly passkeyService: PasskeyService,
    private readonly commonService: CommonService,
    public readonly activeModal: NgbActiveModal,
    public readonly messageService: MessageService,
  ) { }

  ngOnInit(): void {
    this.currentUser = this.authService.getUser;
    this.loadUserDevices();
  }

  async registerFingerprint() {
    if (this.devices.length >= this.MAX_DEVICES) {
        this.showAlertMessage('Warning', 'warn', `You have reached the maximum device limit of ${this.MAX_DEVICES}. Please remove an existing device to register a new one.`);
        return;
    }
    try {
      this.isLoading = true;
      const isCurrentDeviceRegistered = this.checkIfCurrentDeviceIsRegistered();
      
      if (isCurrentDeviceRegistered) {
        this.showAlertMessage('Warning', 'Warn', 'This device is already registered for fingerprint authentication.');
        this.isLoading = false;
        return;
      }
      
      await this.triggerMfaVerification();
      
    } catch (error) {
      console.error('Error in fingerprint registration flow:', error);
      this.isLoading = false;
      this.showAlert(error?.message || "Failed to start fingerprint registration. Please try again.", "Error", "error");
    }
  }

  /**
   * Check if the current device is already registered
   */
  private checkCurrentDeviceRegistration(currentDeviceInfo: any): boolean {
    if (!this.devices || this.devices.length === 0) {
      return false;
    }

    console.log("this.devices", this.devices)
    const currentDeviceFingerprint = this.generateDeviceFingerprint(currentDeviceInfo);
    // currentDeviceFingerprint is now SHA-256 hex string
    return this.devices.some(device => {
        if (device.deviceFingerprint) {
            // Compare the two SHA-256 hex strings
            return device.deviceFingerprint === currentDeviceFingerprint;
        }
        return false;
    });
  }

  /**
   * Check if the current device is already registered (public method for template)
   */
  public checkIfCurrentDeviceIsRegistered(): boolean {
    const currentDeviceInfo = this.passkeyService.getDeviceInfo();
    console.log("currentDeviceInfo>>>>>>>>>>>", currentDeviceInfo)
    this.isCurrentDeviceRegistered = this.checkCurrentDeviceRegistration(currentDeviceInfo);
    console.log("this.isCurrentDeviceRegistered", this.isCurrentDeviceRegistered)
    return this.isCurrentDeviceRegistered;
  }

  /**
   * Generate device fingerprint (same logic as backend)
   */
private normalizeDeviceInfo(deviceInfo: any = {}) {
  return {
    osName: (deviceInfo.osName || "UnknownOS").toLowerCase().trim(),
    // timeZone: this.normalizeTimezone(deviceInfo.timeZone || "UnknownTZ"),
    platform: (deviceInfo.platform || "UnknownPlatform").toLowerCase().trim(),
    language: (deviceInfo.language || "UnknownLang").split('-')[0],
    hardwareConcurrency: Number(deviceInfo.hardwareConcurrency) || 0
  };
}

private generateDeviceFingerprint(deviceInfo: any): string {
  const normalized = this.normalizeDeviceInfo(deviceInfo);

  const deviceString = JSON.stringify(normalized);
  console.log("Normalized device string:", deviceString);

  return CryptoJS.SHA256(deviceString).toString(CryptoJS.enc.Hex);
}

getDeviceDisplayId(device: any): string {
    const fingerprint = device.deviceFingerprint;
    if (fingerprint && fingerprint.length > 6) {
        // Return the last 6 characters of the generated hash
        return 'ID:...' + fingerprint.slice(-6);
    }
    // Fallback if fingerprint is not set or too short
    return 'ID: N/A';
}

  /**
   * Show registration form for new device
   */
  showRegistrationFormForNewDevice() {
    this.showRegistrationForm = true;
    this.isShowDeviceList = false;
    // this.registerFingerprint()
  }

  /**
   * Go back to device list
   */
  backToDeviceList() {
    this.showRegistrationForm = false;
    this.isShowDeviceList = true;
    this.isMfaEnabled = false;
  }

  private async triggerMfaVerification() {
    try {
      const requestData = {
        email: this.currentUser.email,
        fingerPrintData: this.commonService.getMfaFingerPrint(),
        subDomain: window.location.origin
      };
      const response = await this.passkeyService.postCommonHttpClient(apiLinks.validateDeviceVerify,requestData).toPromise()
      console.log("🚀 ~ PasskeyComponent ~ triggerMfaVerification ~ response:", response)
      this.isLoading = false;
      
      if (!response?.mfa) {
        console.log("coming first111111111111111")
        const isBiometricAvailable = await this.passkeyService.isBiometricAvailable();
        if (!isBiometricAvailable) {
          this.showAlert("Passkey authentication is not available on this device.", "Warning", "warn");
          this.isLoading = false;
          return;
        }
        this.isMfaEnabled = true;
        this.mfaData = { ...response };
        this.mfaToken = response.registerToken || response.mfaToken;
        this.formData = {...requestData,uiRefId: response?.uiRefId}
      } else {
        // If MFA is not required, proceed directly to fingerprint registration
        console.log("is this coming?????????????????")
        await this.proceedWithFingerprintRegistration(null,false);
      }
    } catch (error) {
      console.error('Error triggering MFA verification:', error);
      this.isLoading = false;
      throw error;
    }
  }

  async afterSuccessVerifyOtp(event: any) {
    console.log("🚀 ~ PasskeyComponent ~ afterSuccessVerifyOtp ~ event:", event)
    try {
      this.isMfaEnabled = false;
      this.isLoading = false;
      
      // MFA verification successful, proceed with fingerprint registration
      await this.proceedWithFingerprintRegistration(event,true);
      
    } catch (error) {
      console.error('Error after MFA verification:', error);
      this.isLoading = false;
      this.showAlert(error?.message || "Failed to register fingerprint after MFA verification. Please try again.", "Error", "error");
    }
  }

  private async proceedWithFingerprintRegistration(event:any,challenge=false) {
    try {
      this.isLoading = true;
      
      // Check if biometric is available
      const isBiometricAvailable = await this.passkeyService.isBiometricAvailable();
      if (!isBiometricAvailable) {
        this.showAlert("Passkey authentication is not available on this device.", "Warning", "warn");
        this.isLoading = false;
        return;
      }
      const result = await this.passkeyService.registerFingerprint(event,challenge);
      
      console.log('Fingerprint registered successfully:', result);
      this.showAlertMessage('Success', 'Success', 'Fingerprint registered successfully!');
      this.logIntoSetUp = false;
      this.hideMessage = false;
      await this.loadUserDevices();
      this.showRegistrationForm = false;
      this.isShowDeviceList = true;
      
    } catch (error) {
      console.error('Error registering fingerprint:', error);
      this.showAlert("Failed to register fingerprint. Please try again.", "Error", "error");
    } finally {
      this.isLoading = false;
    }
  }


  onError(event: any) {
    console.error('MFA Error:', event);
    this.isMfaEnabled = false;
    this.isLoading = false;
  }

  onBack(event: any) {
    this.isMfaEnabled = false;
    this.isLoading = false;
  }


  async loadUserDevices() {
    try {
      this.isLoading = true;
      this.error = '';
      
      const response = await this.passkeyService.getUserDevices().toPromise();
      this.devices = response?.data || [];
      if(this.devices.length > 0){
        this.isShowDeviceList = true;
        if(this.logIntoSetUp){
          this.showRegistrationFormForNewDevice() 
        }
      }else {
        this.showRegistrationForm = true;
      }
      this.loader = false;
      // this.isDeleteDevice = false;
      this.deletingDeviceId = null;
      
      // Check if current device is registered after loading devices
      this.checkIfCurrentDeviceIsRegistered();
      
    } catch (error) {
      console.error('Error loading user devices:', error);
      this.showAlert("Failed to load registered devices. Please try again.", "Error", "error");
      this.error = error;
      this.isShowDeviceList = false; 
      this.loader = false;
      this.isDeleteDevice = false;
      this.activeModal.close();
    } finally {
      this.isLoading = false;
      this.deletingDeviceId = null;
    }
  }

  async deleteDevice(deviceId: string) {
    this.isDeleteDevice = true;
    this.deletingDeviceId = deviceId; 
    try {
      await this.passkeyService.deleteFingerprint(deviceId).toPromise();
      this.showAlertMessage('Success', 'Success', 'The device has been removed successfully!.');
      this.loadUserDevices();
      
    } catch (error) {
      this.isDeleteDevice = false;
      this.deletingDeviceId = null;
      this.showAlert(error || "Failed to delete registered devices. Please try again.", "Error", "error");
      console.error('Error deleting device:', error);
    }
  }

  getDeviceDisplayName(deviceInfo: any): string {
    if (!deviceInfo) return 'Unknown Device';
    
    const browser = deviceInfo.browserName || 'Unknown Browser';
    const os = this.getOperatingSystem(deviceInfo.userAgent);
    
    return `${browser} on ${os}`;
  }

  getOperatingSystem(userAgent: string): string {
    if (!userAgent) return 'Unknown OS';
    
    if (userAgent.includes('Windows')) return 'Windows';
    if (userAgent.includes('Mac')) return 'macOS';
    if (userAgent.includes('Linux')) return 'Linux';
    if (userAgent.includes('Android')) return 'Android';
    if (userAgent.includes('iOS')) return 'iOS';
    
    return 'Unknown OS';
  }


  getDeviceIcon(deviceInfo: any): string {
    const type = this.getDeviceType(deviceInfo);

    switch (type) {
      case 'mobile':
        return 'mdi mdi-cellphone';
      case 'tablet':
        return 'mdi mdi-tablet';
      case 'desktop':
        return 'mdi mdi-monitor';
      default:
        return 'mdi mdi-devices';
    }
  }


  getDeviceType(deviceInfo: any): string {
    if (!deviceInfo || !deviceInfo.userAgent) return 'unknown';

    const ua = deviceInfo.userAgent.toLowerCase();

    if (ua.includes('android') || ua.includes('iphone') || ua.includes('ipad')) {
      return 'mobile';
    }

    if (ua.includes('tablet')) {
      return 'tablet';
    }

    if (ua.includes('windows') || ua.includes('mac') || ua.includes('linux')) {
      return 'desktop';
    }

    return 'unknown';
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'Unknown';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    } catch (error) {
      console.error('formatDate error:', error);
      return 'Invalid Date';
    }
  }
  close(){
    this.activeModal.close()
  }
  

   showAlertMessage(severity, summary, detail){
    this.messageService.add({
      severity: severity.toLowerCase(),
      summary: summary,
      detail: detail,
      life: 3000

    });
  }

  showAlert(detail, summary, severity) {
    this.messageService.add({
      key: 'show',
      severity,
      summary,
      detail,
      life: 3000 
    });
  } 
  
}
